import { useEffect, useState } from "react";

export const CURRENCIES = [
  { code: "USD", symbol: "$", name: "US Dollar" },
  { code: "EUR", symbol: "€", name: "Euro" },
  { code: "GBP", symbol: "£", name: "British Pound" },
  { code: "JPY", symbol: "¥", name: "Japanese Yen" },
  { code: "CNY", symbol: "¥", name: "Chinese Yuan" },
  { code: "INR", symbol: "₹", name: "Indian Rupee" },
  { code: "CAD", symbol: "CA$", name: "Canadian Dollar" },
  { code: "AUD", symbol: "A$", name: "Australian Dollar" },
  { code: "CHF", symbol: "Fr", name: "Swiss Franc" },
  { code: "KRW", symbol: "₩", name: "South Korean Won" },
  { code: "BRL", symbol: "R$", name: "Brazilian Real" },
  { code: "MXN", symbol: "MX$", name: "Mexican Peso" },
  { code: "SGD", symbol: "S$", name: "Singapore Dollar" },
  { code: "HKD", symbol: "HK$", name: "Hong Kong Dollar" },
  { code: "NOK", symbol: "kr", name: "Norwegian Krone" },
  { code: "SEK", symbol: "kr", name: "Swedish Krona" },
  { code: "DKK", symbol: "kr", name: "Danish Krone" },
  { code: "NZD", symbol: "NZ$", name: "New Zealand Dollar" },
  { code: "ZAR", symbol: "R", name: "South African Rand" },
  { code: "RUB", symbol: "₽", name: "Russian Ruble" },
  { code: "TRY", symbol: "₺", name: "Turkish Lira" },
  { code: "AED", symbol: "د.إ", name: "UAE Dirham" },
  { code: "SAR", symbol: "﷼", name: "Saudi Riyal" },
  { code: "THB", symbol: "฿", name: "Thai Baht" },
  { code: "IDR", symbol: "Rp", name: "Indonesian Rupiah" },
  { code: "MYR", symbol: "RM", name: "Malaysian Ringgit" },
  { code: "PHP", symbol: "₱", name: "Philippine Peso" },
  { code: "PKR", symbol: "₨", name: "Pakistani Rupee" },
  { code: "EGP", symbol: "£", name: "Egyptian Pound" },
  { code: "NGN", symbol: "₦", name: "Nigerian Naira" },
  { code: "KES", symbol: "KSh", name: "Kenyan Shilling" },
  { code: "GHS", symbol: "₵", name: "Ghanaian Cedi" },
  { code: "ILS", symbol: "₪", name: "Israeli Shekel" },
  { code: "PLN", symbol: "zł", name: "Polish Zloty" },
  { code: "CZK", symbol: "Kč", name: "Czech Koruna" },
  { code: "HUF", symbol: "Ft", name: "Hungarian Forint" },
  { code: "RON", symbol: "lei", name: "Romanian Leu" },
  { code: "BGN", symbol: "лв", name: "Bulgarian Lev" },
  { code: "HRK", symbol: "kn", name: "Croatian Kuna" },
  { code: "ARS", symbol: "$", name: "Argentine Peso" },
  { code: "CLP", symbol: "$", name: "Chilean Peso" },
  { code: "COP", symbol: "$", name: "Colombian Peso" },
  { code: "PEN", symbol: "S/.", name: "Peruvian Sol" },
  { code: "VND", symbol: "₫", name: "Vietnamese Dong" },
  { code: "UAH", symbol: "₴", name: "Ukrainian Hryvnia" },
  { code: "BDT", symbol: "৳", name: "Bangladeshi Taka" },
  { code: "LKR", symbol: "Rs", name: "Sri Lankan Rupee" },
  { code: "MMK", symbol: "K", name: "Myanmar Kyat" },
  { code: "QAR", symbol: "﷼", name: "Qatari Riyal" },
  { code: "KWD", symbol: "د.ك", name: "Kuwaiti Dinar" },
  { code: "BHD", symbol: ".د.ب", name: "Bahraini Dinar" },
  { code: "OMR", symbol: "﷼", name: "Omani Rial" },
  { code: "JOD", symbol: "د.ا", name: "Jordanian Dinar" },
  { code: "LBP", symbol: "£", name: "Lebanese Pound" },
  { code: "MAD", symbol: "MAD", name: "Moroccan Dirham" },
  { code: "TND", symbol: "د.ت", name: "Tunisian Dinar" },
  { code: "ETB", symbol: "Br", name: "Ethiopian Birr" },
  { code: "TZS", symbol: "TSh", name: "Tanzanian Shilling" },
  { code: "UGX", symbol: "USh", name: "Ugandan Shilling" },
  { code: "XOF", symbol: "CFA", name: "West African CFA Franc" },
  { code: "XAF", symbol: "FCFA", name: "Central African CFA Franc" },
];

export default function CurrencyDropdown({ currencyCode, currencyChange }) {
  const [selected, setSelected] = useState("USD");
  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    for (let i of CURRENCIES) {
      if (i.code === currencyCode) {
        setSelected(i);
        break;
      }
    }
  }, []);

  const filtered = CURRENCIES.filter(
    (c) =>
      c.name.toLowerCase().includes(search.toLowerCase()) ||
      c.code.toLowerCase().includes(search.toLowerCase()) ||
      c.symbol.includes(search)
  );

  const handleSelect = (currency) => {
    setSelected(currency);
    setOpen(false);
    setSearch("");
    currencyChange(currency.code);
  };

  return (
    <div onClick={(e) => e.stopPropagation()}>
      {/* Trigger Button */}
      <div style={{ position: "relative" }}>
        <div
          onClick={() => setOpen((o) => !o)}
          style={{
            width: "100%",
            padding: "10px 14px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            border: "1px solid #d1d5db",
            borderRadius: 8,
            background: "#fff",
            cursor: "pointer",
            fontSize: 15,
          }}
        >
          <span>
            <strong style={{ marginRight: 8 }}>{selected.symbol}</strong>
            {selected.code} — {selected.name}
          </span>
          <span style={{ fontSize: 12, color: "#6b7280" }}>
            {open ? "▲" : "▼"}
          </span>
        </div>

        {/* Dropdown Panel */}
        {open && (
          <div
            style={{
              position: "absolute",
              top: "calc(100% + 4px)",
              left: 0,
              right: 0,
              background: "#fff",
              border: "1px solid #d1d5db",
              borderRadius: 8,
              boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
              zIndex: 999,
              maxHeight: 300,
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* Search */}
            <div
              style={{ padding: "8px 10px", borderBottom: "1px solid #e5e7eb" }}
            >
              <input
                autoFocus
                placeholder="Search currency..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                style={{
                  width: "100%",
                  padding: "6px 10px",
                  border: "1px solid #d1d5db",
                  borderRadius: 6,
                  fontSize: 14,
                  outline: "none",
                  boxSizing: "border-box",
                }}
              />
            </div>

            {/* List */}
            <div style={{ overflowY: "auto", flex: 1 }}>
              {filtered.length === 0 ? (
                <div
                  style={{
                    padding: "12px 14px",
                    color: "#9ca3af",
                    fontSize: 14,
                  }}
                >
                  No results found
                </div>
              ) : (
                filtered.map((currency) => (
                  <div
                    key={currency.code}
                    onClick={() => handleSelect(currency)}
                    style={{
                      padding: "9px 14px",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      gap: 10,
                      background:
                        selected.code === currency.code
                          ? "#eff6ff"
                          : "transparent",
                      fontSize: 14,
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.background =
                        selected.code === currency.code ? "#eff6ff" : "#f9fafb")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.background =
                        selected.code === currency.code
                          ? "#eff6ff"
                          : "transparent")
                    }
                  >
                    <span
                      style={{
                        width: 30,
                        textAlign: "center",
                        fontWeight: "bold",
                        color: "#374151",
                      }}
                    >
                      {currency.symbol}
                    </span>
                    <span style={{ color: "#6b7280", fontWeight: 600 }}>
                      {currency.code}
                    </span>
                    <span style={{ color: "#374151" }}>{currency.name}</span>
                  </div>
                ))
              )}
            </div>
          </div>
        )}
      </div>

      {/* Display selected */}
      {/* <div
        style={{
          marginTop: "1.5rem",
          padding: "12px 16px",
          background: "#f0fdf4",
          borderRadius: 8,
          border: "1px solid #bbf7d0",
        }}
      >
        <p style={{ margin: 0, fontSize: 14, color: "#166534" }}>
          Selected:{" "}
          <strong>
            {selected.symbol} {selected.code}
          </strong>{" "}
          — {selected.name}
        </p>
      </div> */}
    </div>
  );
}
